import { router } from 'expo-router';
import { useCallback } from 'react';

import { routes } from '@/constants/routes';

import type {
  StandbyEntryDrawerController,
  StandbyEntryTarget,
} from './useStandbyEntryDrawer.types';

// The drawer is native-only (SQR-15490); on web a tap keeps the pre-drawer
// behavior and opens the full status page.
export const useStandbyEntryDrawer = (): StandbyEntryDrawerController => {
  const openEntry = useCallback(({ entryId, shopId }: StandbyEntryTarget) => {
    router.push(routes.standbyEntry(shopId, entryId));
  }, []);

  return { openEntry, drawer: null };
};
